<div class="error-server-container" *ngIf="!isRapidScore">
  <div class="header" role = "banner"></div>
  <div class="left" role="main">
    <div class="container-left">
      <div class="text-information"> <h1>{{ 'ADD_DOCUMENTATION.NEED_MORE_INFO' | translate }}</h1></div>
      <button (click)="close()" *ngIf="show" id="againTry" type="submit">{{ 'ADD_DOCUMENTATION.ATTACH_DOCUMENTATION' | translate }}</button>
    </div>
  </div>
  <div class="right" role = "complementary">
    <div class="imgs-container">
      <img class="oval" src="./assets/temporals/thinking_boy.svg" alt="thinking_boy">
    </div>
  </div>
  <div class="footer">
    <button (click)="close()" *ngIf="show" id="againTry" type="submit">{{ 'ADD_DOCUMENTATION.ATTACH_DOCUMENTATION' | translate }}</button>
  </div>
</div>
<div class="error-server-container-rapidScore" *ngIf="isRapidScore">
  <header class="header" *ngIf="headerFooter" role = "banner">
    <div class="container-logo">
      <div class="logo"><img src="{{ './assets/logos/Logo_SCF_red.png' }}" [ngStyle]="{'cursor': 'auto', 'width':  '130px', 'padding': '0'}" alt="Santander Consumer Logo"></div>
    </div>
  </header>
  <div class="body" role = "main">
    <img src="./assets/login/error-server-rapidScore.png" alt="Error image">
    <div class="message">
      <h1>{{ 'ADD_DOCUMENTATION.NEED_MORE_INFO' | translate }}</h1>
      <button (click)="close()" *ngIf="show" id="againTry" type="submit" aria-label="Button">{{ 'ADD_DOCUMENTATION.ATTACH_DOCUMENTATION' | translate }}</button>
    </div>
  </div>
</div>
